import gtagActions from './gtag/actions';
import jqueryActions from './jquery/actions';
import bottomlineActions from './bottomline/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case gtagActions.INIT_SUCCESS:
      return {
        ...state,
        gtag: true,
      };
    case gtagActions.INIT_FAILED:
      return {
        ...state,
        gtag: false,
      };
    case jqueryActions.INIT_SUCCESS:
      return {
        ...state,
        jquery: true,
      };
    case jqueryActions.INIT_FAILED:
      return {
        ...state,
        jquery: false,
      };
    case bottomlineActions.INIT_SUCCESS:
      return {
        ...state,
        bottomline: true,
      };
    case bottomlineActions.INIT_FAILED:
      return {
        ...state,
        bottomline: false,
      };
    default:
      return state;
  }
};
